import React, { useState, useContext, useEffect } from "react";
import AHPSelect from "../../components/AHPSelect/AHPSelect";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import InfoContext, { AppContext } from "../../context";
import ImmediateConfirmation from "../../components/ImmediateConfirmation/ImmediateConfirmation";
import { searchGoodsStores } from "./searchGoodsStores";
import { GOODS } from "./goodsConstants";
import { Slider, TreeSelect } from "antd";
import { getGoodsCategories } from "./getGoodsCategories";

const { TreeNode } = TreeSelect;

// const getCategoryOptions = (roles, t) => {
//   // goods category options
//   let options = GOODS.CATEGORIES.map((c) => ({
//     value: c,
//     label: t(c),
//   }));

//   // goods categories available for specific roles
//   if (roles?.includes("coworker"))
//     options = [
//       ...options,
//       {
//         label: "Material de escritório",
//         value: "office-supplies",
//       },
//     ];
//   return options;
// };

function GoodsStoreFilter({ setStores }) {
  let info = useContext(AppContext);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [value, setValue] = useState(undefined);

  useEffect(() => {
    (async () => {
      try {
        let remainingCats = await getGoodsCategories();
        const cat = [];
        // add top level categories

        // the following code is used when the categories are registered in the c_categories
        // and each category has a parent category with and id

        let i = 0;
        while (remainingCats.length !== 0) {
          if (i === remainingCats.length) i = 0;
          // if it is a top category
          if (!remainingCats[i].parent_id) {
            cat.push(remainingCats[i]);
            remainingCats[i].parentFound = true;
          } else {
            const index = cat.findIndex(
              (f) => f.id === remainingCats[i].parent_id
            );
            if (index !== -1) {
              if (!cat[index].children) {
                // if first child
                cat[index].children = [remainingCats[i]];
              } else {
                // there are already some children
                cat[index].children.push(remainingCats[i]);
              }
              remainingCats[i].parentFound = true;
            }
          }

          // remove category
          if (remainingCats[i].parentFound) {
            remainingCats = remainingCats.filter((f, index) => index !== i);
          } else i++;
        }

        console.log("categories :>> ", cat);
        setCategories(cat);
      } catch (error) {
        console.log(`error`, error);
      }
    })();
  }, []);

  // // initialize filter
  useEffect(() => {
    //   setCategories(getCategoryOptions(info.user?.roles, info.t));
    //   // minimum and maximum price
    setMinPrice(GOODS.PRICE_RANGE[0]);
    setMaxPrice(GOODS.PRICE_RANGE[1]);
  }, []);

  useEffect(() => {
    (async () => {
      const category = categories.find((c) => c.id === categoryId);
      let categoryIds = [];
      // if category has children, search with those ids
      if (category && category.children && category.children.length > 0)
        category.children.forEach((c) => categoryIds.push(c.id));
      else if (categoryId) categoryIds = [categoryId];

      let goodsStores = await searchGoodsStores(info, categoryIds);

      setStores(goodsStores);
    })();
  }, [
    info.villages,
    info.name,
    info.lodge,
    info.immediateConfirmation,
    categoryId,
  ]);

  const handleSliderChange = (value) => {
    setMinPrice(value[0]);
    setMaxPrice(value[1]);
    info.setGoods({ ...info.goods, minPrice: value[0], maxPrice: value[1] });
  };

  return (
    <>
      <div style={{ display: "flex", marginTop: 10 }}>
        <TreeSelect
          showSearch
          style={{ width: "200px" }}
          value={value}
          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          placeholder={info.t("category")}
          bordered={false}
          allowClear
          treeDefaultExpandAll
          onChange={(value) => setCategoryId(value)}
        >
          {categories.length > 0 &&
            categories.map(
              (c) =>
                c &&
                c.name[info.language] && (
                  <TreeNode
                    value={c.id}
                    title={
                      c.name[info.language].charAt(0).toUpperCase() +
                      c.name[info.language].slice(1)
                    }
                    key={c.name[info.language]}
                  >
                    {c.children?.length > 0 &&
                      c.children.map((el) => (
                        <TreeNode
                          value={el.id}
                          title={
                            el.name[info.language].charAt(0).toUpperCase() +
                            el.name[info.language].slice(1)
                          }
                        ></TreeNode>
                      ))}
                  </TreeNode>
                )
            )}
        </TreeSelect>
        {/* <AHPSelect
          label={info.t("category")}
          type="goods"
          field="category"
          options={categories}
          allowClear
        /> */}

        <div style={{ marginTop: 5, marginRight: 15 }}>
          {info.t("price")}: {minPrice} € - {maxPrice} €
        </div>

        {minPrice != null && maxPrice != null && (
          <Slider
            range
            defaultValue={[GOODS.PRICE_RANGE[0], GOODS.PRICE_RANGE[1]]}
            style={{ width: FIELD_WIDTHS.M }}
            max={GOODS.PRICE_RANGE[1]}
            onAfterChange={handleSliderChange}
          />
        )}
        <ImmediateConfirmation />
      </div>
    </>
  );
}

export default GoodsStoreFilter;
